import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-select",
  "use": "vab-icon-select-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol viewBox=\"0 0 14 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-select\">\n<path d=\"M12.25 3.75H13.75V9.75C13.75 10.575 13.075 11.25 12.25 11.25H1.75C0.925 11.25 0.25 10.575 0.25 9.75V2.25C0.25 1.425 0.925 0.75 1.75 0.75H10.75V2.25H1.75V9.75H12.25V3.75ZM10.75 3.75H3.25V5.25H10.75V3.75ZM9.25 6.75H3.25V8.25H9.25V6.75ZM12.25 2.25H13.75V0.75H12.25V2.25Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol